export default __webpack_public_path__ + "static/media/eww.52b4b5d3.mp3";